import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SendAchMailAction} from '../../achRejectModule/components/ach-reject-list/send-ach-mail.action';
import {AppConstants} from '../../shared/constants/app-constants';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-ach-reject-contact-support-dialog',
    templateUrl: './ach-reject-contact-support-dialog.component.html',
    styleUrls: ['./ach-reject-contact-support-dialog.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AchRejectContactSupportDialogComponent extends SendAchMailAction implements OnInit {

  merchant_payload: {
    merchant_subject: string ,
    merchant_email: string,
    merchant_body: string
  } = { merchant_subject: '', merchant_email: '', merchant_body: ''};
  sendSupport: UntypedFormGroup;
  _sendAchMailUrl: string;
  _sendMailUrl = '/ach-rejects/contact-payarc-support/';
  constructor(private dialog: MatDialogRef<AchRejectContactSupportDialogComponent>, private fb: UntypedFormBuilder,
              dataManager: DataManagerService,
              snackBar: MatSnackBar,
              @Inject('LOCALSTORAGE') private localStorage: any,
              @Inject(MAT_DIALOG_DATA) public data: { merchant_subject: string, merchant_email: string, account_id: string }) {
    super();
    this.snackBar = snackBar;
    this._sendAchMailUrl = AppConstants.BASE_URL + this._sendMailUrl + data.account_id;
    this.dataManager = dataManager;
    this.merchant_payload.merchant_subject = data.merchant_subject;
    this.merchant_payload.merchant_email = data.merchant_email;
  }

  ngOnInit(): void {
    this.sendSupport = this.fb.group({
      merchant_subject: [this.merchant_payload.merchant_subject, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
      merchant_body: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      merchant_email: [{value: this.merchant_payload.merchant_email, disabled: true}]
    });
  }

  closeAction() {
    this.dialog.close(true);
  }
  runAction() {
    this.sendSupport.markAllAsTouched();
    if (this.sendSupport.valid) {
      this.merchant_payload.merchant_subject = this.sendSupport.value.merchant_subject;
      this.merchant_payload.merchant_body = this.sendSupport.value.merchant_body;
      console.log(this.merchant_payload);
      this.callSupport();
    }
  }

  callSupport() {
    const data = {
      subject: this.merchant_payload.merchant_subject,
      reply_to: this.merchant_payload.merchant_email,
      body: this.merchant_payload.merchant_body
    };
    this.sendAchMail(data);
  }
  print(obj) {
    console.log(obj);
  }

  protected passSendAchMailError(err) {
    this.snackBar.open(err.response, 'OK', {
      duration: 0,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['snackbar-success', 'centered-snackbar']
    });
    this.dialog.close(true);
  }

  protected passSendAchMailResponse(res) {
    this.snackBar.open(res.response, 'OK', {
      duration: 0,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['snackbar-success', 'centered-snackbar']
    });
    this.dialog.close(true);
  }
}
